// removed by extract-text-webpack-plugin
module.exports = {"iconContainer":"_1WUPW2jISGTysgMlcv2igA","title":"_2rwGsGAUVztJUtussuyIo4","subTitle":"_3QiMwI8KzhK4qmY1XQShA9","content":"_1T-Glegc2rdyY3Lj2ZCWq2","body":"YaLDew44HOcd6y9Jj0qge","header":"_3jZi0r11aZEOIP4C8v-2lm","extra":"_3e3tW5UnKDAmeLEj647aFC","wrapper":"_2n98d5DfXk4dnhPy6YUZU3","headerOpen":"GzuvHj_PPOWa0z_dl-_v0"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/Event.module.css
// module id = 2345
// module chunks = 1